export default [
  {
    path: '/workspace/:id',
    name: 'workspace.public',
    component: () => import('@/components/workspace/BusinessProfile'),
    redirect: { name: 'workspace.public.contents' },
    children: [
      {
        path: 'lists',
        name: 'workspace.public.lists',
        component: () => import('@/components/workspace/WorkspaceListsTab'),
        children: [
          {
            path: 'manage/:listId?',
            name: 'workspace.public.lists.lists.manage',
            component: () => import('@/components/lists/ModalManageList'),
            meta: {
              backRouteName: 'workspace.public.lists'
            }
          },
          {
            path: 'details/:listId',
            name: 'workspace.public.lists.lists.details',
            component: () => import('@/components/lists/ModalListDetails'),
            meta: {
              backRouteName: 'workspace.public.lists'
            },
            children: [
              {
                path: 'manage',
                name: 'workspace.public.lists.lists.details.lists.manage',
                component: () => import('@/components/lists/ModalManageList'),
                meta: {
                  backRouteName: 'home.user.lists'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'skills',
        name: 'workspace.public.skills',
        component: () => import('@/components/workspace/WorkspaceSkillsTab')
      }
    ]
  }
]
